import { Component } from '@angular/core';

@Component({
  selector: 'app-finance',
  templateUrl: './finance.component.html',
  standalone: false,
})
export class FinanceComponent {}
